import { FlagModule } from '@/modules/featureFlags/domain/models/FlagModule'

import { useFeatureFlagManager } from '../../hooks/useFeatureFlagManager'

export function FeatureFlagManager({
  children
}: {
  children: (props: {
    checkFlag: (flag: FlagModule) => boolean
    checkFlagAndReturn: <T>(flag: FlagModule, toReturn: T) => T[]
  }) => React.ReactNode
}) {
  const { checkFlag, checkFlagAndReturn } = useFeatureFlagManager()
  return children({
    checkFlag,
    checkFlagAndReturn
  })
}
